import { defineStore, StoreDefinition } from 'pinia';
import state from './state.js';
import actions from './actions.js';
import { getters } from './getters.js';

export const useContextStore: StoreDefinition<
    'context',
    typeof state,
    typeof getters,
    typeof actions
> = defineStore('context', {
    state() {
        return state;
    },
    getters,
    actions,
});
